// eslint-disable-next-line import/prefer-default-export
export const hasErrorResponse = (data) => {
  return data.mess
}
